import Vue from 'vue';
import Vuex from 'vuex';
import oauth from './modules/oauth';
import form from './modules/form';
import modif from './modules/modif';
import search from './modules/search';
import rechercheavancee from './modules/rechercheavancee';
import loader from './modules/loader';
import origine from './modules/origine';
import createMultiTabState from 'vuex-multi-tab-state';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    oauth,
    form,
    search,
    rechercheavancee,
    origine,
    modif,
    loader,
  },
  plugins: [
    createMultiTabState({
      statesPaths: [
        'oauth',
        'form',
        'search',
        'rechercheavancee',
        'origine',
        'modif',
        'loader',
      ],
    }),
  ],
});

export default store;
